import { getToken } from '../auth'
import { API_URL } from '../config'

const ASSIGNED_ORDERS_CACHE_KEY = 'pwa_assigned_orders_cache'
const ASSIGNED_ORDERS_CACHE_TTL_MS = 30000

export async function getAssignedOrders(signal, options = {}) {
  try {
    const { force = false, ttlMs = ASSIGNED_ORDERS_CACHE_TTL_MS, cacheOnly = false } = options
    const cachedRaw = sessionStorage.getItem(ASSIGNED_ORDERS_CACHE_KEY)

    if (!force && cachedRaw) {
      try {
        const cached = JSON.parse(cachedRaw)
        const now = Date.now()
        if (cached && cached.savedAt && (now - cached.savedAt) < ttlMs && Array.isArray(cached.data)) {
          return cached.data
        }
      } catch (e) {
        // Ignorar cache corrupto y seguir con la petición.
      }
    }

    if (cacheOnly) return null

    const requestStart = performance.now()
    const token = getToken()

    const res = await fetch(`${API_URL}/orders/assigned`, {
      signal,
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })

    const headersReceived = performance.now()

    if (!res.ok) throw new Error('No se pudieron obtener las órdenes')
    
    const result = await res.json()
    const payloadReceived = performance.now()
    const data = Array.isArray(result.data) ? result.data : []

    try {
      sessionStorage.setItem(ASSIGNED_ORDERS_CACHE_KEY, JSON.stringify({
        data,
        savedAt: Date.now(),
      }))
    } catch (e) {
      // Si no hay almacenamiento disponible, seguir sin bloquear la UX.
    }

    // console.table({
    //   'Backend + red hasta headers (ms)': Math.round(headersReceived - requestStart),
    //   'Descarga + JSON (ms)': Math.round(payloadReceived - headersReceived),
    //   'Solicitud completa (ms)': Math.round(payloadReceived - requestStart),
    // })

    return data

  } catch (e) {
    if (e.name === 'AbortError') {
      throw e
    }
    throw new Error(e.message || 'Error de conexión')
  }
}
